import { render, staticRenderFns } from "./DeviceBulkActions.vue?vue&type=template&id=135ec511"
import script from "./DeviceBulkActions.vue?vue&type=script&lang=js"
export * from "./DeviceBulkActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports